import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { KnowledgeBaseDto } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';

export const KnowledgeBaseShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<KnowledgeBaseDto>({ resource: 'knowledge-bases' });
  const kb = queryResult?.data?.data;

  if (!kb) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="knowledge-bases">
      <div style={{ padding: '8px 0' }}>
        <Field label="Name">{kb.name}</Field>
        <Field label="Description">{kb.description || '—'}</Field>
        <Field label="Entity Type">
          <Tag
            style={{
              borderColor: '#3ecf8e',
              color: '#3ecf8e',
              background: '#3ecf8e15',
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {kb.entityType}
          </Tag>
        </Field>
        <Field label="Entity Count">{kb.entityCount ?? '—'}</Field>
        <Field label="Active">
          <Tag
            style={{
              borderColor: kb.isActive ? '#3ecf8e' : '#898989',
              color: kb.isActive ? '#3ecf8e' : '#898989',
              background: kb.isActive ? '#3ecf8e15' : '#89898915',
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {kb.isActive ? 'Active' : 'Inactive'}
          </Tag>
        </Field>
        <Field label="Created At">{new Date(kb.createdAt).toLocaleString()}</Field>
        <Field label="Updated At">{new Date(kb.updatedAt).toLocaleString()}</Field>
      </div>
    </Show>
  );
};
